import { AbstractControl, FormGroup, ValidationErrors, ValidatorFn } from "@angular/forms";
import { validatePnr } from "./personal-number-handler";

export function pnrValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const value = control.value;

        if (!value) {
            return null;
        }

        const validPnr = validatePnr(value);
        if (!validPnr) {
            control.setErrors({ required: true });
            return { invalidPnr: true };
        }
        return null;
    };
}

export function queryValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const fg = control as FormGroup;
        const concept = +(fg.get("concept")?.value ?? 0);
        let queryControl = fg.get("query");
        const query: string = queryControl?.value;
        let valid = true;

        if (concept && query) {
            switch (concept) {
                case 1: {
                    const regex = /^\d{6,7}$/g;
                    if (!validatePnr(query) && !regex.test(query)) {
                        valid = false;
                    }
                    break;
                }
                case 2: {
                    const regex =
                        /^(?:(?:\d{5,15}|\d{4,7}-\d{4,7}|\d{8}-\d{8}-\d{4}-[A-Za-z]{1}-\d{3})|[A-Za-z]{2,3}(?:-\d{7,12}|\d{4}-\d{4,10})|[A-Za-z]{3}(?:-\d{2}\/\d{3}|-[A-Za-z]{3}\d{6}|-\d{6}-\d{3}|\d{6,7})|[A-Za-z]{2}-(?:[A-Za-z]{2}-[A-Za-z]{1}-\d{2}\/\d{2}|\d{4}-\d{6}))$/g;
                    if (!validatePnr(query) && !regex.test(query)) {
                        valid = false;
                    }
                    break;
                }
                case 3: {
                    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/g;
                    if (!emailRegex.test(query)) {
                        valid = false;
                    }
                    break;
                }
                case 4: {
                    const regex = /^\d{7} ?\d{7}$/g;
                    if (!regex.test(query)) {
                        valid = false;
                    }
                    break;
                }
                case 5: {
                    const regex = /^\d{5,7}$/g;
                    if (!regex.test(query)) {
                        valid = false;
                    }
                    break;
                }
                default: {
                    return null;
                }
            }
        }
        if (!valid) {
            queryControl?.setErrors({ required: true });
            return { invalidQuery: true };
        }
        return null;
    };
}

export function certificateIdentifierValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const fg = control as FormGroup;
        const concept = +(fg.get("concept")?.value ?? 0);
        let certificateIdentifierControl = fg.get("certificateIdentifier");
        const certificateIdentifier: string = certificateIdentifierControl?.value;
        const oldCertificateIdentifier: string = fg.get("oldCertificateIdentifier")?.value;
        let valid = true;

        if (certificateIdentifier && oldCertificateIdentifier) {
            valid = certificateIdentifier.replace(" ", "") !== oldCertificateIdentifier.replace(" ", "");
        }

        if (concept && certificateIdentifier) {
            switch (concept) {
                case 2: {
                    const regex =
                        /^(?:(?:\d{5,15}|\d{4,7}-\d{4,7}|\d{8}-\d{8}-\d{4}-[A-Za-z]{1}-\d{3})|[A-Za-z]{2,3}(?:-\d{7,12}|\d{4}-\d{4,10})|[A-Za-z]{3}(?:-\d{2}\/\d{3}|-[A-Za-z]{3}\d{6}|-\d{6}-\d{3}|\d{6,7})|[A-Za-z]{2}-(?:[A-Za-z]{2}-[A-Za-z]{1}-\d{2}\/\d{2}|\d{4}-\d{6}))$/g;
                    if (!regex.test(certificateIdentifier)) {
                        valid = false;
                    }
                    break;
                }
                case 4: {
                    const regex = /^\d{7} ?\d{7}$/g;
                    if (!regex.test(certificateIdentifier)) {
                        valid = false;
                    }
                    break;
                }
                case 5: {
                    const regex = /^\d{5,7}$/g;
                    if (!regex.test(certificateIdentifier)) {
                        valid = false;
                    }
                    break;
                }
                default: {
                    return null;
                }
            }
        }

        if (!valid) {
            certificateIdentifierControl?.setErrors({ required: true });
            return { invalidCertificateIdentifier: true };
        }
        return null;
    };
}

export function dateValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const value = control.value;

        if (!value) {
            return null;
        }

        const selectedDate = new Date(value);
        const nowDate = new Date();
        const maxDate = new Date(new Date().setFullYear(new Date().getFullYear() + 5));

        const invalidDate = selectedDate < nowDate || selectedDate > maxDate;
        if (invalidDate) {
            control.setErrors({ required: true });
            return { invalidDate: true };
        }
        return null;
    };
}
